var EUserEnum;
(function (EUserEnum) {
    let SystemRole;
    (function (SystemRole) {
        SystemRole[SystemRole["Agent"] = 0] = "Agent";
        SystemRole[SystemRole["ChiefAgent"] = 1] = "ChiefAgent";
        SystemRole[SystemRole["Admin"] = 2] = "Admin";
        SystemRole[SystemRole["SuperAdmin"] = 3] = "SuperAdmin";
    })(SystemRole = EUserEnum.SystemRole || (EUserEnum.SystemRole = {}));
    let UserStatus;
    (function (UserStatus) {
        UserStatus[UserStatus["NoActive"] = 0] = "NoActive";
        UserStatus[UserStatus["Active"] = 1] = "Active";
        UserStatus[UserStatus["Created"] = 2] = "Created";
        UserStatus[UserStatus["Banned"] = 3] = "Banned";
        UserStatus[UserStatus["Deleted"] = 4] = "Deleted";
    })(UserStatus = EUserEnum.UserStatus || (EUserEnum.UserStatus = {}));
})(EUserEnum || (EUserEnum = {}));
export default EUserEnum;
